/* UserAppDataMDVRModel */

import { types } from 'mobx-state-tree'

import UserMDVRSessions from "./UserMDVRSessions"

/* Model Properties */
const UserAppDataMDVRModelProps = {
    sessions: types.optional(UserMDVRSessions, {})
}

/* Model Actions */
const UserAppDataMDVRModelActions = (self) => ({})

const AppDataMDVRModel = types
  .model('AppDataMDVRModel')
  .props(UserAppDataMDVRModelProps)
  .actions(UserAppDataMDVRModelActions)

export default AppDataMDVRModel